import { Sparkles } from 'lucide-react';
import { Card } from './ui/card';

const galleryPhotos = [
  {
    id: 1,
    image: 'https://customer-assets.emergentagent.com/job_wet-clean-pro/artifacts/i3e6t0kv_1000032891.jpg',
    title: 'Professional Cleaning Supplies',
    description: 'Quality products for quality results'
  },
  {
    id: 2,
    image: 'https://customer-assets.emergentagent.com/job_wet-clean-pro/artifacts/jpjazvek_1000032875.jpg',
    title: 'Floor Maintenance',
    description: 'Thorough cleaning, every time'
  },
  {
    id: 3,
    image: 'https://customer-assets.emergentagent.com/job_wet-clean-pro/artifacts/cbajh338_1000032872.jpg',
    title: 'Surface Sanitization',
    description: 'Clean, hygienic, spotless'
  },
  {
    id: 4,
    image: 'https://customer-assets.emergentagent.com/job_wet-clean-pro/artifacts/223v3qqz_1000032874.jpg',
    title: 'Mirror & Glass Cleaning',
    description: 'Attention to detail matters'
  }
];

export const PhotoGallery = () => {
  return (
    <section className="py-28 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-20">
          <div className="flex items-center justify-center gap-2 mb-6">
            <Sparkles className="text-teal-600" size={28} />
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Our Work
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Professional cleaning with care and attention to detail
          </p>
        </div>

        {/* Photo Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {galleryPhotos.map((photo) => (
            <Card 
              key={photo.id}
              className="overflow-hidden border-2 border-gray-200 hover:border-teal-500 transition-all duration-300 hover:shadow-xl group cursor-pointer"
            >
              <div className="relative h-64 overflow-hidden">
                <img
                  src={photo.image}
                  alt={photo.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-0 left-0 right-0 p-4 text-white">
                    <h3 className="font-bold text-lg mb-1">{photo.title}</h3>
                    <p className="text-sm text-gray-200">{photo.description}</p>
                  </div>
                </div>
              </div>
            </Card>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <p className="text-gray-600 text-lg">
            Ready to experience the difference? Let us transform your wet areas.
          </p>
        </div>
      </div>
    </section>
  );
};
